module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 208
// module chunks = 0